import { render, staticRenderFns, recyclableRender, components } from "./search-page.vue?vue&type=template&id=d1dd5134&scoped=true&"
var renderjs
import script from "./search-page.vue?vue&type=script&lang=js&"
export * from "./search-page.vue?vue&type=script&lang=js&"
import style0 from "./search-page.vue?vue&type=style&index=0&lang=css&"
import style1 from "./search-page.vue?vue&type=style&index=1&id=d1dd5134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1dd5134",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/search/search-page.vue"
export default component.exports